import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { DialogResponse } from 'owa-confirm-dialog';
import { lazyDisplayInsertLinkDialog, InsertLinkProperties } from 'owa-editor-ribbonplugin';
import strings from 'owa-strings/owa-mail-strings';
import { ReplaceLinkHandler } from '../../components/LinkContextMenu';

export function getEditLinkContextMenuItem(
    anchorElement: HTMLAnchorElement,
    editUrlHandler: ReplaceLinkHandler
): IContextualMenuItem {
    // preload lazyDisplayInsertLinkDialog
    lazyDisplayInsertLinkDialog.import();
    return {
        name: strings.editHyperlink,
        key: 'EditLink',
        onClick: () => {
            logUsage('AttachmentLinkViewEditLink');
            editLink(anchorElement, editUrlHandler);
        },
    };
}

async function editLink(anchorElement: HTMLAnchorElement, editUrlHandler: ReplaceLinkHandler) {
    const insertLink: InsertLinkProperties = {
        LinkUrl: anchorElement.href,
        DisplayText: anchorElement.innerText,
        HasChanged: false,
    };
    const displayInsertLinkDialog = await lazyDisplayInsertLinkDialog.import();
    if (
        (await displayInsertLinkDialog(insertLink)) === DialogResponse.ok &&
        insertLink.HasChanged
    ) {
        editUrlHandler(
            insertLink.LinkUrl,
            insertLink.DisplayText.length > 0 ? insertLink.DisplayText : null
        );
    }
}
